import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const LectureUploadDialog = ({ 
  visible, 
  onHide, 
  formData, 
  handleInputChange, 
  handleFileChange, 
  handleSubmit, 
  loading 
}) => {
  if (!visible) return null;

  return (
    <div className="lectures-modal-overlay">
      <div className="lectures-modal">
        <div className="lectures-modal-header">
          <h2>Upload Lecture</h2>
          <button onClick={onHide} className="lectures-modal-close">
            <XMarkIcon className="w-6 h-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="lectures-modal-form">
          <div className="lectures-form-group">
            <label htmlFor="title" className="lectures-form-label">Title *</label>
            <b>:</b>
            <input type="text" id="title" name="title" value={formData.title}
              onChange={handleInputChange} placeholder="Enter title" className="lectures-form-input" disabled={loading}
            />
          </div>

          <div className="lectures-form-group">
            <label htmlFor="description" className="lectures-form-label"> Description *</label>
            <b>:</b>
            <textarea id="description" name="description" value={formData.description} onChange={handleInputChange}
              placeholder="Enter lecture description" className="lectures-form-textarea" disabled={loading} />
          </div>

          <div className="lectures-form-group">
            <label htmlFor="lectureFile" className="lectures-form-label"> File (Video,Audio,Document)*</label>
            <b>:</b>
            <div className="lectures-file-input-wrapper">
              <input type="file" id="lectureFile" name="lectureFile" onChange={handleFileChange} className="lectures-file-input" accept=".pdf,.mp4,.mov,.avi,.doc,.docx,.ppt,.pptx" disabled={loading} />
              <span className="lectures-file-input-text">
                {formData.lectureFile ? formData.lectureFile.name : 'Click to upload or drag and drop'}
              </span>
            </div>
          </div>

          <div className="lectures-form-group">
            <label htmlFor="thumbnail" className="lectures-form-label"> Thumbnail (Optional)</label>
            <b>:</b>
            <div className="lectures-file-input-wrapper">
              <input type="file" id="thumbnail" name="thumbnail" onChange={handleFileChange} className="lectures-file-input" accept=".jpg,.jpeg,.png,.gif" disabled={loading} />
              <span className="lectures-file-input-text">
                {formData.thumbnail ? formData.thumbnail.name : 'Click to upload image'}
              </span>
            </div>
          </div>

          <div className="lectures-modal-footer">
            <button type="button" className="lectures-btn-cancel" disabled={loading} onClick={onHide}> Cancel</button>
            <button type="submit" className="lectures-btn-submit" disabled={loading}>
              {loading ? 'Uploading...' : 'Upload Lecture'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LectureUploadDialog;
